/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconOpenInNewTab12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M10.5 7.128a.75.75 0 0 1 .75.75v2.25c0 .622-.504 1.125-1.125 1.125h-8.25A1.125 1.125 0 0 1 .75 10.128v-8.25c0-.62.504-1.125 1.125-1.125h2.25a.75.75 0 0 1 0 1.5H2.25v7.5h7.5V7.878a.75.75 0 0 1 .75-.75ZM9.225 2.091V1.85l-.862.236c-.404.11-.82.166-1.238.166a.728.728 0 0 1-.75-.751.75.75 0 0 1 .75-.75H10.5a.75.75 0 0 1 .75.75v3.378a.75.75 0 0 1-.75.75.73.73 0 0 1-.75-.75c0-.42.056-.837.167-1.241l.235-.86H9.91l-.809 1.077a7.498 7.498 0 0 1-.697.804L5.78 7.282A.75.75 0 1 1 4.72 6.22l2.625-2.625c.25-.249.517-.48.799-.692l1.081-.813Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconOpenInNewTab16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M14 9.505a1 1 0 0 1 1 1v3a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5v-11a1.5 1.5 0 0 1 1.5-1.5h3a1 1 0 0 1 0 2H3v10h10v-2.5a1 1 0 0 1 1-1Zm-1.7-6.716v-.324l-1.15.315A6.259 6.259 0 0 1 9.5 3c-.6 0-1-.448-1-1.001a1 1 0 0 1 1-1H14a1 1 0 0 1 1 1v4.505a1 1 0 0 1-1 1c-.552 0-1-.403-1-1 0-.56.075-1.117.222-1.656l.313-1.147h-.32l-1.078 1.437a10 10 0 0 1-.93 1.072l-3.5 3.498a1 1 0 0 1-1.414-1.414l3.5-3.5c.334-.332.69-.641 1.065-.923L12.3 2.789Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconOpenInNewTab20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M16.667 11.667a.833.833 0 0 0-.833.833v2.564c0 .382-.018.476-.068.57a.303.303 0 0 1-.131.13c-.094.051-.188.07-.57.07H4.936c-.382 0-.475-.019-.57-.07a.303.303 0 0 1-.13-.13c-.05-.094-.069-.188-.069-.57V4.584c0-.23.186-.417.416-.417L7.5 4.17a.833.833 0 1 0 .002-1.666L4.584 2.5A2.084 2.084 0 0 0 2.5 4.583v10.481c0 .634.069.988.266 1.356.187.35.466.628.815.815.368.197.722.265 1.355.265h10.129c.634 0 .987-.068 1.356-.265a1.97 1.97 0 0 0 .814-.815c.198-.369.266-.722.266-1.356V12.5a.833.833 0 0 0-.834-.833ZM15.001 4.12v-.243l-.325.075a8.334 8.334 0 0 1-1.874.214h-1.135a.833.833 0 1 1 0-1.667l4.584.002c.69 0 1.25.56 1.25 1.25v4.581a.833.833 0 1 1-1.667 0V7.2c0-.63.072-1.26.213-1.874L16.122 5h-.246A8.333 8.333 0 0 1 14.7 6.479l-4.943 4.944a.833.833 0 0 1-1.179-1.179l4.953-4.953a8.336 8.336 0 0 1 1.47-1.17Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconOpenInNewTab24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M20 14a1 1 0 0 0-1 1v3.077c0 .459-.02.57-.081.684a.363.363 0 0 1-.157.157c-.113.06-.225.082-.684.082H5.924c-.459 0-.571-.022-.684-.082a.363.363 0 0 1-.157-.157c-.06-.113-.082-.225-.082-.684L5 5.5a.5.5 0 0 1 .5-.5l3.5.005a1 1 0 0 0 .002-2L5.502 3A2.5 2.5 0 0 0 3 5.5v12.577c0 .76.083 1.185.32 1.627.223.419.558.753.977.977.442.237.866.319 1.627.319h12.154c.76 0 1.185-.082 1.627-.319.419-.224.753-.558.977-.977.237-.442.319-.866.319-1.627V15a1 1 0 0 0-1-1Zm-2-9.055v-.291l-.39.09A10 10 0 0 1 15.363 5h-1.361a1 1 0 0 1 0-2l5.5.003a1.5 1.5 0 0 1 1.5 1.5V10a1 1 0 1 1-2 0V8.639c0-.757.086-1.511.256-2.249l.09-.39h-.295a10.004 10.004 0 0 1-1.412 1.775l-5.932 5.932a1 1 0 0 1-1.414-1.414l5.944-5.944A10.003 10.003 0 0 1 18 4.945Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconOpenInNewTab = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconOpenInNewTab(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconOpenInNewTab12 {...iconProps} />;
        case '16':
            return <IconOpenInNewTab16 {...iconProps} />;
        case '20':
            return <IconOpenInNewTab20 {...iconProps} />;
        case '24':
            return <IconOpenInNewTab24 {...iconProps} />;
        default:
            return <IconOpenInNewTab24 {...iconProps} />;
    }
});
